import React from 'react'
import PropTypes from 'prop-types'

import { Icon, Image, Link, Text } from 'Components/UI'

import { isObject, isString } from 'lodash'
import size from 'lodash/size'

import { Container, Content, ImageHolder } from './styles'

function Plate({ data, platform, invert, ...rest }) {
  if (!size(platform)) return null
  const { logo, title } = platform

  return (
    <Link.External href={data?.link}>
      <Container {...rest}>
        <Content>
          {logo && (
            <ImageHolder mr={[3, 12]}>
              {isString(logo) && <Image alt="" image={logo} lazy />}
              {isObject(logo) && <Icon glyph={logo} size={20} />}
            </ImageHolder>
          )}
          <Text medium white={!invert}>
            {data?.title || title}
          </Text>
        </Content>
      </Container>
    </Link.External>
  )
}

Plate.defaultProps = {
  data: {},
  invert: 0,
  platform: {},
}

Plate.propTypes = {
  data: PropTypes.object,
  invert: PropTypes.number,
  platform: PropTypes.object,
}

export default Plate
